
(() => {
  if (window.flachlandProduktbilderAktiv) return;
  window.flachlandProduktbilderAktiv = true;

  const bilder = {
    leder: 'LH_Satt_SEC.png',
    taco: {
      'Schwarz': 'H_TC_BLK.png',
      'Olive Drab': 'H_TC_OD.png',
      'Orange': 'H_TC_HO.png',
      'Coyote': 'H_TC_CY.png'
    },
    tacoStrap: {
      'Schwarz': 'H_TC_Strap_BLK.png',
      'Olive Drab': 'H_TC_Strap_OD.png',
      'Orange': 'H_TC_Strap_HO.png',
      'Coyote': 'H_TC_Strap_CY.png'
    },
    pancake: {
      'Schwarz': 'H_PC_BLK.png',
      'Olive Drab': 'H_PC_OD.png',
      'Orange': 'H_PC_HO.png',
      'Coyote': 'H_PC_CY.png'
    },
    pancakeStrap: {
      'Schwarz': 'H_PC_Strap_BLK.png',
      'Olive Drab': 'H_PC_Strap_OD.png',
      'Orange': 'H_PC_Strap_HO.png',
      'Coyote': 'H_PC_Strap_CY.png'
    },
    referenz: {
      taco: 'H_TC_Referenz.png',
      pancake: 'H_PC_Referenz.png',
      tacoStrap: 'H_TC_Strap_Referenz.png',
      pancakeStrap: 'H_PC_Strap_Referenz.png'
    }
  };

  function bildsteuerung(galerie) {
    const bild = galerie.querySelector('.product__media-item.is-active img')
      || galerie.querySelector('.product__media-item img');

    if (!bild) return null;

    const originalSrc = bild.src;
    const originalSrcset = bild.srcset;

    return function(dateiname) {
      if (dateiname) {
        bild.removeAttribute('srcset');
        bild.src = '/cdn/shop/files/' + dateiname;
        bild.style.objectFit = 'contain';
      } else {
        bild.src = originalSrc;
        if (originalSrcset) {
          bild.srcset = originalSrcset;
        } else {
          bild.removeAttribute('srcset');
        }
        bild.style.objectFit = '';
      }
    };
  }

  function holsterInitialisieren() {
    const root = document.querySelector('[data-fl-config]');
    if (!root) return;

    const material = root.querySelector('[data-fl-material]');
    const bauart = root.querySelector('[data-fl-build]');
    const farbe = root.querySelector('[data-fl-color]');
    const sicherung = root.querySelector('[data-fl-lock]');
    const galerie = document.querySelector('media-gallery');

    if (!material || !bauart || !farbe || !sicherung || !galerie) {
      return;
    }

    const bildSetzen = bildsteuerung(galerie);
    if (!bildSetzen) return;

    let letztesBild = undefined;

    function aktualisieren() {
      let dateiname = null;

      if (material.value === 'Leder') {
        dateiname = bilder.leder;
      } else if (material.value === 'Kydex') {
        const typ = bauart.value;
        const farbname = farbe.value;
        const mitThumbBreak = sicherung.value === 'tegris';

        if (typ === 'taco' || typ === 'pancake') {
          const bildtyp = mitThumbBreak
            ? typ + 'Strap'
            : typ;

          dateiname = bilder[bildtyp][farbname]
            || bilder.referenz[bildtyp]
            || null;
        }
      }

      if (dateiname === letztesBild) return;

      letztesBild = dateiname;
      bildSetzen(dateiname);
    }

    function aktualisierungPlanen() {
      requestAnimationFrame(aktualisieren);
    }

    [material, bauart, farbe, sicherung].forEach(feld => {
      feld.addEventListener('change', aktualisierungPlanen);
    });

    const observer = new MutationObserver(aktualisierungPlanen);

    [bauart, farbe, sicherung].forEach(feld => {
      observer.observe(feld, {
        childList: true,
        subtree: true
      });
    });

    aktualisierungPlanen();
  }

  function fDickInitialisieren() {
    const galerie = document.querySelector('media-gallery');
    if (!galerie) return;

    const bilderNachFarbe = {
      'Schwarz': null,
      'Olive Drab': null,
      'Orange': null,
      'Grau': null
    };

    const farbauswahl = document.querySelector('[data-fl-fd-color]');
    if (!farbauswahl) return;

    const bildSetzen = bildsteuerung(galerie);
    if (!bildSetzen) return;

    function aktualisieren() {
      bildSetzen(bilderNachFarbe[farbauswahl.value] || null);
    }

    farbauswahl.addEventListener('change', aktualisieren);
    aktualisieren();
  }

  function initialisieren() {
    holsterInitialisieren();
    fDickInitialisieren();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialisieren);
  } else {
    initialisieren();
  }
})();
